// auth
import ContentFormatXX from '../content/webz/content-format-xx';
import WebbDividerSmall from '../content/webx/webb-divider-sm';
import WebbDividerMedium from '../content/webx/webb-divider-md';

import AuthMailCheckModule from '../content/auth/auth-mail-check';


export default function AuthMailCheck() {
  
  return (
    <ContentFormatXX 
      head = {'Account Access'}
      home = {`/`}
      link = {`/`}
      form = {'mini'}
      data = {
        <>
          <WebbDividerMedium />
          <AuthMailCheckModule />
          
        </>
        
      }  
    /> 
  )
}